<template>
  <div class="car-card">
    <div class="car-card__image-container">
      <a
        :class="{ 'car-card__disabled-link': disabledLink }"
        target="_blank"
        :href="car.link"
        @click.stop
      >
        <img v-if="car.imageUrl" :src="car.imageUrl" alt="" />
      </a>
    </div>
    <div class="car-card__body">
      <a
        :class="{ 'car-card__disabled-link': disabledLink }"
        :href="car.link"
        target="_blank"
        class="car-card__title"
        @click.stop
        >{{ car.title }}</a
      >
      <div class="car-card__info">
        <div class="car-card__info-make-year">
          <div class="car-card__make">
              Make:
              <span class="car-card__make-value">{{car.make}}</span>
          </div>
          <div class="car-card__year">
              Year:
              <span class="car-card__year-value">{{car.year}}</span>
          </div>
        </div>
        <div class="car-card__model">
            Model:
            <span class="car-card__model-value">{{car.model}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VCarCard',

  props: {
    car: {
      type: Object
    }
  },

  computed: {
    disabledLink () {
      return !this.car.link
    }
  }
}
</script>
